import { render, staticRenderFns } from "./dashboard-page.vue?vue&type=template&id=5d6aded2&scoped=true&"
import script from "./dashboard-page.vue?vue&type=script&lang=js&"
export * from "./dashboard-page.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-page.vue?vue&type=style&index=0&id=5d6aded2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6aded2",
  null
  
)

export default component.exports